import { beeSwarmPosition } from "@/components/VivoPlots/functions/utils/beeswarmPostion";
import * as d3 from "d3";

export const calculateSwarmplotPosition = async (data: any, scales: any) => {
  const categoricalScale = scales.find(
    (scale: any) => scale.type === "categorical",
  );
  const subgroupScale = scales.find(
    (scale: any) => scale.type === "subgroup" && scale.dataMapping !== "none",
  );
  const continuousScale = scales.find(
    (scale: any) => scale.type === "continuous",
  );

  const flatPreswarmData = data.flatMap((d: any) => {
    const xCenter = subgroupScale
      ? categoricalScale.scale(d.category) +
        subgroupScale.scale(d.subgroup) +
        subgroupScale.scale.bandwidth() / 2
      : categoricalScale.scale(d.category) +
        categoricalScale.scale.bandwidth() / 2;

    return d.values.map((v: any) => ({
      x: xCenter,
      y: continuousScale.scale(v.value),
      r: 5,
      data: {
        category: d.category,
        subgroup: d.subgroup,
        ssjIdValue: v.ssjIdValue,
        subjectId: v.subjectId,
        entityKey: v.entityKey,
        subjectValue: v.value,
        isOutlier: v.isOutlier,
        fill: v.fill,
        rawRow: v.rawRow,
      },
    }));
  });

  // Pass flat data to worker
  const positionedPoints = await beeSwarmPosition(
    flatPreswarmData,
    3,
    0.5,
    10,
    subgroupScale
      ? subgroupScale.scale.bandwidth()
      : categoricalScale.scale.bandwidth(),
  );

  // Group back by category + subgroup (optional if needed for plot)
  const grouped = d3.group(
    positionedPoints,
    (d) => (d.data?.category ?? "") + "|" + (d.data?.subgroup ?? ""),
  );

  // Transform into expected swarmData shape
  const swarmData = Array.from(grouped, ([key, points]) => {
    const [category, subgroup] = key.split("|");
    return {
      category,
      subgroup,
      points,
    };
  });

  return swarmData;
};
